import * as fromDatatype from "../datatype-library/index";

export interface bl_pgw_payment_channel_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  min_price_limit: fromDatatype.BigIntegerDatatypeInterface;
  max_price_limit: fromDatatype.BigIntegerDatatypeInterface;
  mode: fromDatatype.VarcharDatatypeInterface;
  mode_start_date: fromDatatype.TimestampTzDatatypeInterface;
  mode_end_date: fromDatatype.TimestampTzDatatypeInterface;
  acquirer_entity_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  fixed_amounts: fromDatatype.JsonDatatypeInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
  payment_provider_priority: fromDatatype.IntegerDatatypeInterface;
  payment_provider_status: fromDatatype.VarcharDatatypeInterface;
  credit_limit_usage_from_date: fromDatatype.TimestampTzDatatypeInterface;
  credit_limit_usage_amount: fromDatatype.BigIntegerDatatypeInterface;
  credit_limit_initial_amount: fromDatatype.BigIntegerDatatypeInterface;
  credit_limit_available_amount: fromDatatype.BigIntegerDatatypeInterface;
}

export class bl_pgw_payment_channel_hdr_RowClass
  implements bl_pgw_payment_channel_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  min_price_limit: fromDatatype.BigIntegerDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  max_price_limit: fromDatatype.BigIntegerDatatypeInterface;
  mode: fromDatatype.VarcharDatatypeInterface;
  mode_start_date: fromDatatype.TimestampTzDatatypeInterface;
  mode_end_date: fromDatatype.TimestampTzDatatypeInterface;
  acquirer_entity_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  fixed_amounts: fromDatatype.JsonDatatypeInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
  payment_provider_priority: fromDatatype.IntegerDatatypeInterface;
  payment_provider_status: fromDatatype.VarcharDatatypeInterface;
  credit_limit_usage_from_date: fromDatatype.TimestampTzDatatypeInterface;
  credit_limit_usage_amount: fromDatatype.BigIntegerDatatypeInterface;
  credit_limit_initial_amount: fromDatatype.BigIntegerDatatypeInterface;
  credit_limit_available_amount: fromDatatype.BigIntegerDatatypeInterface;
}
